// Web console session (plain browser, outside Telegram).
// Token minted by POST /api/auth/telegram-widget; stored raw under a fixed key.

import { tg } from './telegram';

const STORAGE_KEY = 'dubaiotc_web_session';

export function getWebSession(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setWebSession(token: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Storage unavailable (private mode) — session lasts the page load only.
  }
}

export function clearWebSession(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clear.
  }
}

// Web context = no Telegram initData. telegram-web-app.js loads in plain
// browsers too, but initData stays empty outside a real WebView session.
export function isWebContext(): boolean {
  return !tg()?.initData;
}
